import React from 'react';
import Modal from '@omilia/modal';

// @ts-ignore
import messages from 'constants/messages';
import ModalLoader from '../ModalLoader';

const UpdateBranchLoadingModal = () => (
  <Modal
    open
    data-test="version-control-modal"
    glyph="update-from-parent"
    hasBackdrop={false}
    title="Update from Parent"
  >
    <ModalLoader
      text={messages.VERSION_CONTROL.MERGE_MODAL.CHECKING_MERGE_PARENT}
    />
  </Modal>
);

export default UpdateBranchLoadingModal;
